export default __webpack_public_path__ + "static/media/Ellen 9781408350775.72ef994d.jpg";